import { render, staticRenderFns } from "./productProgram.vue?vue&type=template&id=5cead547&scoped=true&"
import script from "./productProgram.vue?vue&type=script&lang=js&"
export * from "./productProgram.vue?vue&type=script&lang=js&"
import style0 from "./productProgram.vue?vue&type=style&index=0&id=5cead547&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cead547",
  null
  
)

export default component.exports